import { useState } from 'react'
import { Mail } from 'lucide-react'
import { useNewsletterSubscription } from '@/hooks/useNewsletterSubscription'

export function NewsletterSignup() {
  const [email, setEmail] = useState('')
  const { subscribe, isSubscribing } = useNewsletterSubscription()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    try {
      await subscribe({ email })
      setEmail('')
    } catch {
      // Error is handled by the hook
    }
  }

  return (
    <form onSubmit={handleSubmit} className="flex w-full max-w-sm gap-2">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        className="flex-1 rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white placeholder-gray-500 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 disabled:opacity-50"
        disabled={isSubscribing}
      />
      <button
        type="submit"
        disabled={isSubscribing}
        className="inline-flex items-center gap-1 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50 transition-colors"
      >
        <Mail className="h-4 w-4" />
        {isSubscribing ? 'Subscribing...' : 'Subscribe'}
      </button>
    </form>
  )
}
